import { Redirect, useLocalSearchParams } from 'expo-router'

import { isAdminUrl } from '@/src/features/admin/utils/adminWebViewNavigation'
import { getLegacyUrl } from '@/src/general/utils/getLegacyUrl'

export default function AdminScreen() {
  const { url } = useLocalSearchParams<{ url?: string | string[] }>()
  return <Redirect href={typeof url === 'string' && isAdminUrl(url) ? url : getLegacyUrl('/admin/animator-space')} />
}
